import React, { useState, useEffect} from 'react';
import { useSearchParams, useParams } from "react-router-dom";
import { CheckCircle, XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { API_URL_BASE, URL_BASE } from './config';
import './css/ticketconfirm.css';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default function PrivateConfirmation() {
  const {eventid} = useParams(); 
  const [searchParams] = useSearchParams();
  const [confirmResult, setConfirmResult] = useState('');
  const [ticketConfirm, setTicketConfirm] = useState('');
  const [eventResult, setEventResult] = useState('');
  const { t } = useTranslation();
  const eventName = eventResult?.event?.name || "Event Name";
  const eventdDateTime = eventResult?.event?.startdatetime || "Event Time";
  const eventAddress = eventResult?.event?.address || "Event Venue";
  
  useEffect(() => {
	const orderId = searchParams.get("orderId");
	const paymentMethod = searchParams.get("paymentMethod");

	  // 1.  Don't fetch if required params are missing
	  if (!orderId || !paymentMethod) return;
	  
	  const controller = new AbortController();

	  async function confirmOrder() {

	    try {

      const response = await fetch(API_URL_BASE + `/sales.json`,{
  		method: 'POST',
  		     headers: {
  		       'Content-Type': 'application/json',
  		     },
			 signal: controller.signal,
  		     body: JSON.stringify({
  		       confirm: {
  		           token: searchParams.get('orderId'),
				   paymentMethod: searchParams.get('paymentMethod')
  		       }
  		     }),
  		   });
		   
         if (!response.ok) {
			throw new Error('Event not found');
		 } 
        
		 const data = await response.json();
		 const result = data.confirmResult;
		 
		if(result){
			setConfirmResult(result);
				// Only set tickets if payment was successful
				if (result.status === true) {
				  setTicketConfirm(result.products?.product || []);
				} else {
				  setTicketConfirm([]);
				}
			 }
		} catch (err) {
			   if (err.name !== "AbortError") {
			     console.error("Confirm order error:", err);
			     
			   }
			 }	 
		}
		
		confirmOrder();

		return () => controller.abort();
		},[searchParams]);
		
		
	useEffect(() => {
		fetch(API_URL_BASE + `/ticket.json`,{
		method: 'POST',
			     headers: {
			       'Content-Type': 'application/json',
			     },
			     body: JSON.stringify({
			       fetchEventDetailForPurchase: {
						eventId: eventid
			       }
			     }),
			   })
		   .then(res => {
		     if (!res.ok) throw new Error('Event not found');
		     return res.json();
		   })
		   .then(data => {
		     setEventResult(data.eventdetails); // Adjust based on your actual response shape						
		   })
		   .catch(err => {
		     console.error('Error loading event:', err);
		     setEventResult(null);
		   });
		
	}, [eventid]);
				

	if (!confirmResult?.invoiceID) {
		return (
			<div className="processing-page">
				<div className="spinner"></div>
				 <h2>Processing your payment <span className="dots">...</span></h2>
				 <p>Please wait, do not refresh this page…</p>
			</div>
		)
	}	

  return (
	<div>
    <div className="confirmation-container">
		{/* Header based on payment status */}
		{confirmResult?.status === true ? (
		  <div className="confirmation-header">
		    <CheckCircle className="icon-success" strokeWidth={1.5} color="white"/>
		    <h1>{t("paysuccess")}</h1>
		  </div>
		) : confirmResult?.status === false ? (
		  <div className="confirmation-header canceled">
		    <XCircle className="icon-error" strokeWidth={1.5} color="white" />
		    <h1>{t("status")}</h1>
		    <p>{confirmResult.message}</p>
		  </div>
		) : null}

		{/* Event info */}
		{confirmResult ? (
		<div>	
	        <div className="confirmation-event-header">
	          <h2>{eventName}</h2>
	          <p className="order-id">Order ID: {confirmResult.invoiceID}</p>
	        </div>

		{/* Tickets (only if payment succeeded) */}
		{confirmResult?.status === true ? (
	
				<div className="ticketsconfirm-list">	
						{/* PDF target wrapper */}
						<div  className="ticketconfirm-card"> 
							<div className="ticketconfirm-right">	
								<div>{t('emailmsg')}</div>
							</div>
						</div>
				</div>		
		) : 			(
				     <div>
				     <p className="footer-note">{t("tryagain")}</p>
				     <a style={{ textAlign: "center", display: "block" }} href= {`${URL_BASE}/pay/${eventid}`} > {t("buy")} </a>
				     </div>
				   ) } 
	   

		</div>
		) : null 
		}

	
		 
    </div>
	
	<div className='footer'>
	<span>© Processed by Buydeal.EU B.V</span>
	</div>
	
	</div>
  );
}
